(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("babylonjs"), require("babylonjs-gui"));
	else if(typeof define === 'function' && define.amd)
		define("babylonjs-node-render-graph-editor", ["babylonjs", "babylonjs-gui"], factory);
	else if(typeof exports === 'object')
		exports["babylonjs-node-render-graph-editor"] = factory(require("babylonjs"), require("babylonjs-gui"));
	else
		root["NODERENDERGRAPHEDITOR"] = factory(root["BABYLON"], root["BABYLON"]["GUI"]);
})((typeof self !== "undefined" ? self : typeof global !== "undefined" ? global : this), (__WEBPACK_EXTERNAL_MODULE__5597__, __WEBPACK_EXTERNAL_MODULE__5490__) => {
return 